export default __webpack_public_path__ + "static/media/gallery_01.3365437d.jpg";